/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Connected from './Connected/index'
import Disconnected from './Disconnected/index'
import Error from './Error/index'
import No from './No/index'
import React from 'react'
import SetupAutomations from './SetupAutomations/index'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/Status"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let connectionStatusValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'status',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: connectionStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Connected'}>
<Connected
  viewPath={`${viewPath}/Connected`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Disconnected'}>
<Disconnected
  viewPath={`${viewPath}/Disconnected`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SetupAutomations'}>
<SetupAutomations
  viewPath={`${viewPath}/SetupAutomations`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}